/* Inveo SCRIPTS */

// MENU HANDLER
const menuEl = document.querySelector('.js-menu');
const menuNavigation = document.querySelector(".c-header__menu-inner").children;

const hideMenuItems = () => {
	for (let menuNavigationElement of menuNavigation) {
		menuNavigationElement.style.visibility = "hidden";
	}
};
const showMenuItems = () => {
	for (let menuNavigationElement of menuNavigation) {
		menuNavigationElement.style.visibility = "visible";
	}
};

const onStartMenu = () => {
	if(window.screen.width <= 768){
		hideMenuItems();
	} else {
		showMenuItems();
	}
};
const closeMenu = () => {
	document.querySelector('.js-hamburger').classList.remove('c-header__hamburger--active');
	document.querySelector('.js-menu').classList.remove('c-header__menu--active');
	document.body.style.position = "relative";
	if(window.screen.width <= 768){
		hideMenuItems();
	}
};
const openMenu = () => {
	document.querySelector('.js-hamburger').classList.add('c-header__hamburger--active');
	document.querySelector('.js-menu').classList.add('c-header__menu--active');
	document.body.style.position = "fixed";
	if(window.screen.width <= 768){
		showMenuItems();
	}
};

// Hide menu items on load & resize for mobile version
["load", "resize"].forEach( event =>
	window.addEventListener(event, onStartMenu)
);

// Close menu after click on each element
for (let menuNavigationElement of menuNavigation) {
	menuNavigationElement.addEventListener("click", () => {
		closeMenu();
	})
}

// Open/Close menu after click on "hamburger"
document.querySelector('.js-hamburger').addEventListener('click',  (e) => {
	e.preventDefault();
	if(menuEl.classList.contains('c-header__menu--active')) {
		closeMenu();
	} else {
		openMenu();
	}
});

// SCROLL ON PROJECTS
const homepageCaseStudies = document.querySelector('#casestudies');
const projectsButton = document.querySelector('#menu-menu-1 li:first-of-type a');

const projectScroll = function (scrollItem) {
	scrollItem.scrollIntoView({behavior: "smooth"});
};

projectsButton.addEventListener('click', function(event){
	event.preventDefault();
	closeMenu();

	if (homepageCaseStudies) {
		projectScroll(homepageCaseStudies);
	} else {
		window.location.href= window.location.origin + projectsButton.hash;
	}
});

// CAREER FORM WPCF7
const fileInput = document.querySelector(".wpcf7-file__input input");
const labelFile = document.querySelector('.wpcf7-file__label-wad');
const urlField = document.getElementById("urlField");
const submitBtn = document.querySelector('.wpcf7-submit-div');

if(fileInput) {
	fileInput.addEventListener('change', function() {
		labelFile.innerHTML = fileInput.files[0].name;
	});
}

if(urlField) {
	urlField.value = window.location.href;
}

if (submitBtn) {
	const arrow = document.createElement('div');
	arrow.classList.add('wpcf7-submit-arrow');
	submitBtn.append(arrow);
}
document.addEventListener('DOMContentLoaded', function() {
	const urlInput = document.querySelector('#urlField');
	if (urlInput != null) {
		const urlString = urlInput.value.split('https://www.');
		// const urlString = urlInput.value.split('http://'); // localtest
		urlInput.value = urlString[1];
	}
})

// NEW GLOBAL ANIMATION - dark background + reveal on scroll
window.addEventListener('load', function () {
	const unitedBgElements = Array.from(document.querySelectorAll('.js-bg-color *'));
	const unitedBgTexts = unitedBgElements.filter(item => item.innerText);
	unitedBgTexts.map(text => text.classList.add('text-scroll-dark'));

	const hiddenElementsAnimation = document.querySelectorAll('.js-hidden');
	const backgroundChangeAnim = document.querySelector('.js-bg-color');

	const options = {
		root: null,
		rootMargin: '-50px 0px',
		threshold: 0.1
	};
	const optionsBg = {
		root: null,
		rootMargin: '0px',
		threshold: 0.07
	};

	function scrollTrigger(selectorArr) {
		selectorArr.forEach(el => {
			addObserver(el)
		})
	}

	function addObserver(el){
		let observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('showed');
				}
			})
		}, options)
		observer.observe(el);
	}

	function addObserverBg(el){
		let observerBg = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('blue');
					unitedBgTexts.map(text => text.classList.remove('text-scroll-dark'));
				} else {
					entry.target.classList.remove('blue');
					unitedBgTexts.map(text => text.classList.add('text-scroll-dark'));
				}
			})
		}, optionsBg)
		observerBg.observe(el);
	}
	scrollTrigger(hiddenElementsAnimation);
	addObserverBg(backgroundChangeAnim);
})

// videos plays on hover
const videos = Array.from(document.querySelectorAll('.c-activity__video'));

videos.forEach((video) => {
	video.addEventListener('mouseenter', () => {
		video.play();
	})
})

// scroll on contacts || footer
const scrollBtnsToFooter = document.querySelectorAll('.js-footer-scroll');
const preFooterBlock = document.querySelector('.c-prefooter');
const footerBlock = document.querySelector('.c-footer');

if (scrollBtnsToFooter.length > 0) {
	scrollBtnsToFooter.forEach(btn => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			setTimeout(()=> {
				if (preFooterBlock) {
					preFooterBlock.scrollIntoView({behavior: 'smooth'});
				} else {
					footerBlock.scrollIntoView({behavior: 'smooth'});
				}
			},50)
		})
	})
}
